var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-show-view',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var adjustment = ref.item;
return [_c('v-simple-table',[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.l('pages.adjustments.properties.name')))]),_c('td',[_vm._v(_vm._s(_vm._f("name")(adjustment)))])])])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }